import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> Networking/Infrastructure</li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>Infrastructure Security Testing (Internal/External)</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  Your IT infrastructure is the backbone of your business —
                  hosting applications, storing sensitive data, and enabling
                  day-to-day operations. But it’s also a prime target for
                  cybercriminals. <b>Infrastructure Security Testing</b> helps
                  identify and mitigate vulnerabilities across servers,
                  networks, devices, and services before attackers can exploit
                  them. Whether it’s internal threats (originating from inside
                  your network) or external threats (from the internet), this
                  testing ensures your organization is protected against
                  breaches, downtime, and data loss.
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  {
                    icon: "fa-arrows-down-to-people",
                    title: "Comprehensive Coverage",
                    desc: "Cybercriminals don’t just target web apps — they exploit weak network configurations, unpatched servers, and exposed services.",
                  },
                  {
                    icon: "fa-database",
                    title: "Dual Threat Landscape",
                    desc: "Internal users (malicious insiders or compromised accounts) and external attackers both pose risks.",
                  },
                  {
                    icon: "fa-shield-halved",
                    title: "Business Continuity",
                    desc: "A single misconfigured firewall or exposed port can disrupt operations.",
                  },
                  {
                    icon: "fa-table",
                    title: "Compliance Requirements",
                    desc: "Standards like PCI DSS, ISO 27001, and NIST mandate infrastructure-level testing.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Reputation Protection",
                    desc: "Preventing breaches protects your brand and customer trust.",
                  },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* Methodology */}
                    <div
                      className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>
                        Our Infrastructure Security Testing methodology follows
                        international standards such as OWASP, OSSTMM and NIST
                        guidelines, combining automated scans with expert manual
                        analysis.
                      </p>
                      <ul>
                        <li><b>Discovery & Mapping :-</b> Identifying live hosts, services, and network devices.</li>
                        <li><b>Vulnerability Assessment :-</b> Scanning for unpatched systems, insecure configurations, and weak protocols.</li>
                        <li><b>Internal Testing :-</b> Simulating threats from within the organization to detect insider risks and lateral movement opportunities.</li>
                        <li><b>External Testing :-</b> Assessing exposure from the internet to identify entry points for attackers.</li>
                        <li><b>Exploitation & Validation :-</b> Safely verifying vulnerabilities without disrupting business operations.</li>
                        <li><b>Reporting & Remediation :-</b> Providing detailed findings with prioritized mitigation strategies.</li>
                        <li><b>Re-testing :-</b> Confirming vulnerabilities are fully resolved.</li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <ul>
                        <li>Identify vulnerabilities in networks, servers, and devices before attackers do.</li>
                        <li>Protect against insider threats and external breaches alike.</li>
                        <li>Ensure compliance with regulatory and industry standards.</li>
                        <li>Reduce risk of downtime, data breaches, and financial losses.</li>
                        <li>Strengthen resilience against modern cyberattacks like ransomware and lateral movement.</li>
                        <li>Gain clarity on your infrastructure’s real-world security posture.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>At the conclusion of an Infrastructure Security Testing engagement, you will receive:</p>
                      <ul>
                        <li><b>Detailed Security Report :-</b> Comprehensive list of vulnerabilities with severity ratings.</li>
                        <li><b>Remediation Roadmap :-</b> Practical recommendations to fix identified issues.</li>
                        <li><b>Executive Summary :-</b> Clear, non-technical overview for leadership.</li>
                        <li><b>Re-testing & Validation :-</b> Assurance that vulnerabilities are patched correctly.</li>
                        <li><b>Continuous Security Advisory :-</b> Ongoing guidance to strengthen infrastructure security.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ---------- */}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach</h3>
                  <p>We don’t just scan your infrastructure — we think like attackers and act like defenders.</p>
                  <ul>
                    <li><b>Internal & External Focus :-</b> Holistic testing that simulates both insider and outsider threats.</li>
                    <li><b>Expert-Driven Testing :-</b> Certified security professionals conduct manual validation beyond automated tools.</li>
                    <li><b>Customizable Engagements :-</b> Tailored testing for on-premises, hybrid, or cloud-based infrastructure.</li>
                    <li><b>Business-Aware Assessments :-</b> Findings are prioritized by business impact, not just technical severity.</li>
                    <li><b>Compliance Alignment :-</b> Testing aligned with PCI DSS, ISO 27001, HIPAA, and NIST frameworks.</li>
                    <li><b>End-to-End Partnership :-</b> From vulnerability discovery to remediation support and re-validation.</li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------ */}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
